import React, {useCallback, useMemo, useState} from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
} from "react-router-dom";
import {Sidenav, Nav, Sidebar} from 'rsuite';
import BarChart from "@rsuite/icons/BarChart";
import BarLineChart from "@rsuite/icons/BarLineChart";
import {Branch, Calendar, Dashboard, Gear, Page, PeopleExpand, Review, Scatter, Task} from "@rsuite/icons";
import routes from './Routes'

import {useSelector} from "react-redux";
import {CLOSED_WIDTH, EXPANDED_WIDTH, HEADER_HEIGHT} from "../constants/navWidths";


const ResumeSideNav = () => {

    const userInfo = useSelector((state) => state.user.userInfo );
    const expanded = useSelector((state) => state.sidenav.expanded );

    // default to user dashboard
    const [activeKey, setActiveKey] = useState( 22);

    const handleSelect = useCallback((eventKey) => {
        setActiveKey(eventKey);
    }, []);

    return useMemo(() => {
            return (
                <Router>
                    <Sidebar
                        style={{display: 'flex', flexDirection: 'column'}}
                        width={expanded ? EXPANDED_WIDTH : CLOSED_WIDTH}
                        collapsible
                    >
                        <Sidenav
                            expanded={expanded}
                            style={{position: 'sticky', top: HEADER_HEIGHT, height: '93.846vh'}} // 60 px = 6.154vh
                        >
                            <Sidenav.Body>
                                <Nav
                                    activeKey={activeKey}
                                    onSelect={handleSelect}
                                >
                                    <Nav.Menu eventKey="20" title="Dashboards" icon={<Dashboard />}>
                                        {userInfo?.role === 'ADMIN' ?
                                            <Nav.Item as={Link} to="/admindashboard" eventKey="21" icon={<BarChart />}>
                                                Admin Dashboard
                                            </Nav.Item> :
                                            null }
                                        <Nav.Item as={Link} to="/" eventKey="22" icon={<Task />}>
                                            User Dashboard
                                        </Nav.Item>
                                    </Nav.Menu>
                                    <Nav.Item as={Link} to="/skills" eventKey="3" icon={<Scatter />}>
                                        Skills
                                    </Nav.Item>
                                    <Nav.Item as={Link} to="/experience" eventKey="4" icon={<Calendar />}>
                                        Experience
                                    </Nav.Item>
                                    <Nav.Item as={Link} to="/projects" eventKey="5" icon={<Branch />}>
                                        Projects
                                    </Nav.Item>
                                    <Nav.Item as={Link} to="/education" eventKey="6" icon={<PeopleExpand />}>
                                        Education
                                    </Nav.Item>
                                    <Nav.Item as={Link} to="/certifications" eventKey="7"
                                              icon={<Review />}>
                                        Certifications
                                    </Nav.Item>
                                    <Nav.Item as={Link} to="/preview" eventKey="8" icon={<Page />}>
                                        Preview Resume
                                    </Nav.Item>
                                    {userInfo?.role === 'REPORTER' || userInfo?.role === 'ADMIN' ?
                                        <Nav.Item as={Link} to="/reporting" eventKey="9" icon={<BarLineChart />}>
                                            Reporting
                                        </Nav.Item> :
                                        null }
                                    {userInfo?.role === 'ADMIN' ?
                                        <Nav.Item as={Link} to="/admin" eventKey="10" icon={<Gear />}>
                                            Admin
                                        </Nav.Item> :
                                        null }
                                </Nav>
                                <div style={{fontSize: '0.75rem', padding: '0.5rem'}}>{expanded ? process.env.REACT_APP_VERSION : '...' }</div>
                            </Sidenav.Body>
                        </Sidenav>
                    </Sidebar>
                    <div style={{flex: 1, padding: "0.5rem"}}>
                        <Switch>
                            {routes.map((route, index) => (
                                <Route
                                    key={index}
                                    path={route.path}
                                    exact={route.exact}
                                    children={<route.main/>}
                                />
                            ))}
                        </Switch>
                    </div>
                </Router>
            )
        }, [activeKey, expanded, handleSelect, userInfo]
    );
}

export default ResumeSideNav;